import { API_URL } from '../../config/env';
import { Injectable } from '../../decorators/injectable';
import type { IInviteService, InviteDetails, MagicLinkResponse } from './invite.service.interface';

export class InviteError extends Error {
  readonly status: number;
  readonly code?: string;

  constructor(message: string, status: number, code?: string) {
    super(message);
    this.name = 'InviteError';
    this.status = status;
    this.code = code;
  }
}

/**
 * Invite service.
 * GET (details) uses plain fetch (public, no auth needed).
 * Magic link creation also uses plain fetch (public endpoint).
 */
@Injectable()
export class InviteService implements IInviteService {
  private readonly baseUrl: string;

  constructor() {
    this.baseUrl = API_URL.endsWith('/') ? API_URL : `${API_URL}/`;
  }

  async getByToken(token: string, tenantId: string): Promise<InviteDetails> {
    const response = await fetch(
      `${this.baseUrl}invite/${encodeURIComponent(token)}?tenantId=${encodeURIComponent(tenantId)}`,
    );
    if (!response.ok) {
      throw new InviteError(`Invite request failed: ${response.status}`, response.status);
    }
    return response.json();
  }

  async createMagicLink(token: string, tenantId: string): Promise<MagicLinkResponse> {
    const response = await fetch(
      `${this.baseUrl}invite/${encodeURIComponent(token)}/magic-link?tenantId=${encodeURIComponent(tenantId)}`,
      { method: 'POST' },
    );
    if (!response.ok) {
      throw new InviteError(`Magic link failed: ${response.status}`, response.status);
    }
    return response.json();
  }
}
